import barba from 'barba'
import transition from './transitions/default'
import './global/scroll'
import './global/mutation'
import './global/cdv'
import './global/preload'

barba.init({
    // Debug mode
    // https://barba.js.org/docs/advanced/recipes/#debug
    debug: !location.host.endsWith('devinci.com'),
    // Prevent click on link during transition
    // https://barba.js.org/docs/advanced/strategies/#preventRunning
    preventRunning: true,
    // Custom prevent test
    // https://barba.js.org/docs/advanced/strategies/#Prevent
    prevent: ({ href }) => {
        // Browser is lacking scrollRestoration, 
        // navigation won't be optimal, prevent all link
        if ('scrollRestoration' in window.history === false) {
            return true
        }
        // Media file test
        const url = href.split('?')[0]
        if (/\.[a-z]{2,4}$/i.test(url)) {
            return true
        }
        // Default
        return false
    },
    // Timeout if request take more then 1s
    // https://barba.js.org/docs/advanced/recipes/#timeout
    timeout: 10000,
    // Manage request error
    // https://barba.js.org/docs/advanced/recipes/#requestError
    requestError: (trigger, action, url, response) => {
        // Href of hyperlink is a 404 ...
        if (typeof trigger === "object"
            && trigger.tagName
            && trigger.tagName === 'A'
            && response.status
            && response.status === 404) {
            // ... prevent trough data attr (force without transition)
            // https://barba.js.org/docs/advanced/strategies/#prevent
            trigger.dataset.barbaPrevent = "self"
        }
    },
    // Transitions
    // https://barba.js.org/docs/getstarted/basic-transition/
    // https://barba.js.org/docs/advanced/transitions/
    transitions: [
        transition,
        // The 'self' name has a special meaning, a transition with
        // this name will allow barba.go() method to transition to
        // the same page. This will also cause anchor (ex. href="#anchor") 
        // to transition like a page. You will need a custom implementation
        // of anchor behavior.
        {
            ...transition,
            name: 'self'
        }
    ]
})